import { fetchClinic } from "@client/clinic";
import { ClinicResource } from "@client/resources/ClinicResource";
import { QueryOptionsTyped } from "@hooks/queries/types";
import { ApiResponse } from "@typeDefinitions";
import { useQuery } from "@tanstack/react-query";

import { clinicKeys } from "./clinicKeys";

export const useFetchClinicQuery = (
  options?: QueryOptionsTyped<ApiResponse<ClinicResource>>,
) => {
  return useQuery({
    queryKey: clinicKeys.clinic(),
    queryFn: fetchClinic,
    ...options,
  });
};
